<template>
    <div class="record-choose layout-sub-page">
        <!-- 1. 顶部title -->
        <title-bar
            v-bind:titleData="titleData"
            v-bind:backFunc="hideChooseRecord"
            v-bind:createFunc="confirmChooseRecord">
        </title-bar>
        <!-- 2. 下拉框和搜索框 -->
        <div class="record-choose-bar record-top-part">
            <div class="dsp-flex">
                <div class="record-choose-side" @click.passive="clickSelectRecord">
                    <div class="record-choose-select">
                        <span class="record-choose-select-span">{{curFilterData.text.slice(0, 4)}} <i class="iconfont rob-icon icon-down"></i></span>
                    </div>
                </div>
                <div class="record-choose-search">
                    <search-input 
                        v-bind:className="'record-choose-input'"
                        v-bind:inputId="searchInputId"
                        v-bind:searchData="searchData"
                        v-bind:inputFunc="inputSearch">
                    </search-input>
                </div>
            </div>
            <!-- 3. 创建新的命盘按钮 -->
            <div v-if="chooseFromPage != 'contrast' && chooseFromPage != 'contrastlist' && chooseFromPage != 'detail' && chooseFromPage != 'marriage'" class="record-create-new dsp-flex" @click="clickCreateNew">
                <div class="record-create-btn">创建新的命盘</div>
                <div><i class="iconfont icon-xiangyou"></i></div>
            </div>
        </div>
        <!-- 3. 列表 -->
        <record-choose-list v-show="chooseSearchResultList.length == 0">
        </record-choose-list>

        <!-- 4. 搜索结果显示 -->
        <record-search-list 
            v-show="chooseSearchResultList.length > 0"
            :resultList="chooseSearchResultList">
        </record-search-list>

        <!-- 5. 字母列表 -->
        <letter-side-bar
            v-if="gotRecordData"
            v-show="chooseSearchResultList.length == 0">
        </letter-side-bar>

        <router-view></router-view>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import SearchInput from '../../components/SearchInput.vue'
import RecordChooseList from '../../layouts/record/RecordChooseList.vue'
import LetterSideBar from '../../layouts/record/LetterSideBar.vue'
import RecordSearchList from '../../layouts/record/RecordSearchList.vue'
import { RECORD_DOM, FAMOUS_DOM } from '../../modules/dom'
import { MIX } from '../../modules/utils'
export default {
    name: 'ChooseRecord',
    components: { TitleBar, SearchInput, RecordChooseList, LetterSideBar, RecordSearchList },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        gotRecordRecentlyData() {
            return this.$store.state.record.gotRecordRecentlyData;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        curFilterData() {
            return this.$store.state.allrecord.curFilterData;
        },
        recordLetterList() {
            return this.$store.state.recordletter.recordLetterList;
        },
        chooseFromPage() {
            return this.$store.state.chooserecord.chooseFromPage;
        },
        chooseRecordType() {
            return this.$store.state.chooserecord.chooseRecordType;
        },
        curChoosedSingleItem() {
            return this.$store.state.chooserecord.curChoosedSingleItem;
        },
        chooseSearchResultList() {
            return this.$store.state.chooserecord.chooseSearchResultList;
        }
    },
    data() {
        return {
            searchInputId: 'chooseSearchInput',
            titleData: {
                'titleText': '选择或创建新的命盘',
                'showCancel': false,
                'hideButton': true,
                'titleCreate': '确定'
            }
        }
    },
    mounted() {
        this.initDom();
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
        // 重置数据
        if(this.chooseFromPage != 'contrast' && this.chooseFromPage != 'detail') {
            // 重置搜索模块数据
            this.$store.dispatch('search/resetData');
            this.$store.dispatch('chooserecord/resetData');
        }
        setTimeout(() => {
            // 数据为最近浏览100条
            this.$store.state.record.recordCurOrderIndex = 3;
            this.$store.dispatch('record/updateRecordFilterList');
            MIX.trackPageViewed('CompareSelectPage');
        }, 20);
    },
    methods: {
        initDom() {
            // 设置标题和一些UI
            if(this.chooseFromPage == 'famouspedia') {
                this.$set(this.titleData, 'titleText', '选择目标对象');
            }
            if(this.chooseFromPage == 'contrast' || this.chooseFromPage == 'contrastlist' || this.chooseFromPage == 'detail') {
                this.$set(this.titleData, 'titleText', '选择对比对象');
            }
            setTimeout(() => {
                this.$el.style.width = innerWidth + 'px';
                this.$el.style.height = innerHeight + 'px';
            }, 100);

            // setTimeout(() => {
            //     RECORD_DOM.resetChooseRecordLetterSideBarStyle();
            // }, 100);
        },
        inputSearch(word) {
            this.$store.state.search.searchData.searchText = word;
            if(word != ''){
                this.$store.dispatch('chooserecord/getChoosedSearchResultList', word);
            }else{
                this.$store.state.chooserecord.chooseSearchResultList = [];
                // setTimeout(() => {
                //     RECORD_DOM.resetChooseRecordLetterSideBarStyle();
                // }, 20);
            }
        },
        hideChooseRecord() {
            if(this.chooseFromPage) {
                let curpath = this.$router.history.current.path;
                    curpath = curpath.replace('/chooserecord', '');
                this.$router.replace(curpath);
                // if(this.chooseFromPage == 'contrast') {
                //     let contrastData = this.$store.state.contrast.contrastData;
                //     if(!contrastData) { return; }
                //     this.$router.replace('/'+this.chooseFromPage+'/'+contrastData.id);
                // }else {
                //     this.$router.replace('/'+this.chooseFromPage);
                // }
            }else {
                this.$router.replace('/record');
            }
            this.$store.dispatch('chooserecord/resetData');
        },
        clickSelectRecord() {
            let curpath = this.$router.history.current.path;
                curpath = curpath.replace('/chooserecord', '/chooserecord/all');
            // var path = '/'+this.chooseFromPage+'/chooserecord/all'
            this.$router.replace(curpath);
        },
        clickCreateNew() {
            this.$store.dispatch('chooserecord/resetData');
            this.$store.dispatch('collate/resetData');
            var path = '/'+this.chooseFromPage+'/choosecreate'
            this.$router.push({
                path: path
            });
        },
        confirmChooseRecord() {
            let curData = this.chooseRecordType == 'single' ? this.curChoosedSingleItem : null;
            let me = this,
                originalData = this.$store.state.record.recordOriginalData,
                itemData = curData ? originalData[curData.id] : null;
            let contrastData = this.$store.state.contrast.contrastData;
            let choosedList = this.$store.state.chooserecord.choosedMultipleItemList;
            console.log('confirmChooseRecord-----', curData, itemData, this.chooseRecordType, this.chooseFromPage);
            switch(this.chooseFromPage) {
                case 'marriage':
                    if(itemData == null || !curData.selected) {
                        this.$toast('请选择命盘');
                        return;
                    }
                    this.$store.dispatch('marriage/confirmChooseItem', itemData);
                    this.$router.replace('/marriage');
                    break;
                case 'famouspedia':
                case 'famouspediacreate':
                    if(itemData == null || !curData.selected) {
                        this.$toast('请选择命盘');
                        return;
                    }
                    this.$store.dispatch('famouspedia/addBaike', {
                        data: itemData,
                        cb: function() {
                            me.$toast('创建百科草稿成功，可在[我的百科]中查看');
                            setTimeout(() => {
                                me.$router.replace('/famouspediaedit');
                            }, 100);
                            // 清空搜索数据
                            me.$store.dispatch('search/resetData');
                        }
                    });
                    break;
                case 'discussmain':
                case 'discusssecond':
                    if(itemData == null || !curData.selected) {
                        this.$toast('请选择命盘');
                        return;
                    }
                    this.$store.dispatch('detail/initDetail', itemData);
                    this.$router.push({
                        path: '/discusscreate'
                    });
                    break;
                case 'contrastlist':
                    if(choosedList.length < 2) {
                        this.$toast('请至少选择两个八字');
                        return;
                    }
                    this.$store.dispatch('contrast/addContrast', {
                        choosedList: choosedList,
                        cb: (cData)=> {
                            this.$store.state.chooserecord.choosedMultipleItemList = [];
                            this.$router.replace('/contrast/contrastlist/'+cData.id)
                        }
                    });
                    break;
                case 'contrast':
                    if(!contrastData.id) { return; }
                    console.log('contrast-----', choosedList);
                    if(choosedList.length == 0) {
                        this.$router.replace('/contrast/contrastlist/'+contrastData.id);
                    }else {
                        this.$store.dispatch('contrast/updateContrast', {
                            type: 'bzid_add',
                            value: choosedList.map(el => {return el.id}),
                            cb: ()=> {
                                this.$store.state.chooserecord.choosedMultipleItemList = [];
                                this.$router.replace('/contrast/contrastlist/'+contrastData.id);
                            }
                        });
                    }
                    break;
                case 'detail':
                    let detailData = this.$store.state.detail.personInfo;
                        choosedList.push(detailData);
                    let curPath = this.$router.history.current.path;
                    let curParams = this.$router.history.current.params;
                    console.log('chooserecord-----', choosedList, curPath, curParams);
                    this.$store.dispatch('contrast/addContrast', {
                        choosedList: choosedList,
                        cb: (cData)=> {
                            let newPath = curPath.indexOf('search') != -1 ? '/contrast/'+this.chooseFromPage+'_'+curParams.from+'/'+cData.id : '/contrast/'+this.chooseFromPage+'/'+cData.id;
                            this.$store.state.chooserecord.choosedMultipleItemList = [];
                            this.$router.replace(newPath);
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    }
}
</script>